import { Component, OnInit, ViewChild, AfterViewInit, AfterViewChecked, Inject } from '@angular/core';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { Employeedetails } from '../../../interface/delegationofauthority/employeedetails';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DoaDetail, GroupedDoaDetail } from '../../../interface/delegationofauthority/doatypelist';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { redelegationsToFrom } from '../../../interface/delegationofauthority/category';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-displaypage',
  imports: [FormsModule, ReactiveFormsModule, CommonModule, MatTableModule, MatPaginatorModule, MatProgressSpinner],
  templateUrl: './displaypage.component.html',
  styleUrls: ['./displaypage.component.css']
})
export class DisplaypageComponent implements OnInit, AfterViewInit, AfterViewChecked {
  employeeDetails: Employeedetails = {
    employeeNo: '',
    surname: '',
    initials: '',
    deptName: '',
    divisionName: '',
    jobTitle: '',
    phoneExt: '',
    preferredName: '',
    reportstocai: '',
    reportsToEmailAddress: ''
  };
  effectiveDate: string = '';
  conversionRate: string = '';
  doaDetails: DoaDetail[] = [];
  groupedDoaDetails: GroupedDoaDetail[] = [];
  redelegationsTo: redelegationsToFrom[] = [];
  redelegationsFrom: redelegationsToFrom[] = [];
  showFields: boolean = false;
  showTable: boolean = false;
  showFromTable: boolean = false;
  errorMessage: string = ''; // Added errorMessage property

  displayedColumns: string[] = ['note', 'doaType', 'dollar'];
  redelegationsDisplayedColumns: string[] = ['sno', 'name', 'from', 'to'];

  paginatedRedelegationsTo = new MatTableDataSource<redelegationsToFrom>();
  paginatedRedelegationsFrom = new MatTableDataSource<redelegationsToFrom>();

  @ViewChild('paginatorTo') paginatorTo!: MatPaginator;
  @ViewChild('paginatorFrom') paginatorFrom!: MatPaginator;

  constructor(
    private delegationService: DelegationofauthorityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private overlay: Overlay,
    private dialogRef: MatDialogRef<DisplaypageComponent>
  ) {}

  ngAfterViewInit(): void {
    this.paginatedRedelegationsTo.paginator = this.paginatorTo;
    this.paginatedRedelegationsFrom.paginator = this.paginatorFrom;
  }

  ngOnInit(): void {
  
    const empNo = this.data.employeeNo;
    if(empNo==0){
      this.errorMessage = "Delegation not found"; 
    }
    else {
      this.delegationService.getEmployeeDetailsByEmpNo(empNo).subscribe(
        (data: Employeedetails) => {
          this.employeeDetails = data;
        }
      );
      this.delegationService.getEffectiveDate(empNo).subscribe(
        (date: string) => {
          this.effectiveDate = date;
        }
      );
      this.delegationService.getDoaDetails(empNo).subscribe(
        (details: DoaDetail[]) => {
          this.doaDetails = details;
          this.groupedDoaDetails = this.groupBy(details, ['catName']);
        }
      );
      this.showFields = true;
      this.delegationService.getRedelegations(empNo).subscribe(
        (redelegations: redelegationsToFrom[]) => {
          this.redelegationsTo = redelegations.filter(r => r.isTo === '1').sort((a, b) => this.parseDate(b.startDate).getTime() - this.parseDate(a.startDate).getTime());
          this.redelegationsFrom = redelegations.filter(r => r.isTo !== '1').sort((a, b) => this.parseDate(b.startDate).getTime() - this.parseDate(a.startDate).getTime());
          this.paginatedRedelegationsTo = new MatTableDataSource(this.redelegationsTo);
          this.paginatedRedelegationsFrom = new MatTableDataSource(this.redelegationsFrom);
          this.paginatedRedelegationsTo.data = this.redelegationsTo;
          this.paginatedRedelegationsFrom.data = this.redelegationsFrom;
          this.showFields = false;
        }
      );
   
    this.delegationService.getConversionRate().subscribe(
      (rate: string) => {
        this.conversionRate = rate;
      }
    );
  }
  }

  ngAfterViewChecked(): void {
    if (this.paginatorTo && !this.paginatedRedelegationsTo.paginator) {
      this.paginatedRedelegationsTo.paginator = this.paginatorTo;
    }
    if (this.paginatorFrom && !this.paginatedRedelegationsFrom.paginator) {
      this.paginatedRedelegationsFrom.paginator = this.paginatorFrom;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  groupBy(array: DoaDetail[], keys: (keyof DoaDetail)[]): GroupedDoaDetail[] {
    const grouped: { [key: string]: GroupedDoaDetail } = {};
    array.forEach(item => {
      const key = keys.map(k => item[k]).join('|');
      if (!grouped[key]) {
        grouped[key] = { catName: item.catName, catTitle: item.catTitle, catCode: item.catCode, subCatName: '', noteCode: '', types: [] };
      }
      const displayCode = item.noteCode || item.subCatNote;
      grouped[key].types.push({ noteCode: displayCode, subCatName: item.subCatName, typeName: item.typeName, dollar: item.dollar });
    });
    return Object.values(grouped);
  }

  printPage(): void {
    this.showTable = true;
    this.showFromTable = true;
    setTimeout(() => {
      window.print();
      this.ngAfterViewInit();
    }, 1000);
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  toggleTable(): void {
    this.showTable = !this.showTable;
    if (this.showTable) {
      this.paginatedRedelegationsTo.paginator = this.paginatorTo;
    }
  }

  toggleFromTable(): void {
    this.showFromTable = !this.showFromTable;
    if (this.showFromTable) {
      this.paginatedRedelegationsFrom.paginator = this.paginatorFrom;
    }
  }

  private parseDate(dateString: string): Date {
    const parts = dateString.split('-');
    const day = parseInt(parts[0], 10);
    const month = this.getMonthFromString(parts[1]);
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  private getMonthFromString(month: string): number {
    return new Date(Date.parse(month + " 1, 2021")).getMonth();
  }
}
